import { genMstColumns } from '@libs/templates/mst';
import type { Column } from '@ps-smart-cp/ppfw-client';
import { locationMstRegistrationFieldConfig } from '../item-config';
import type { LocationMstRegistration } from '../models';

const locationMstColumns: Column<LocationMstRegistration>[] = [
  ...genMstColumns<LocationMstRegistration>(),
  {
    displayName: locationMstRegistrationFieldConfig.address,
    renderCell: ({ row }) => row.address,
  },
];

export { locationMstColumns };
